@for (foot of [].constructor(pagesCount || 1); track $index) {
  <div class="holder forceDefaultColors" #footerHolder>
    @if (isDocumentWhitelabelLoaded) {
      @if (documentFooterType === FooterTypeEnum.Mini) {
        <!-- MINI FOOTER PREVIEW -->
        <div class="footer footer-mini" [style.height]="maxMiniFooterHeight + 'px'">
          <div class="footer-mini__left">
            <img [src]="documentWhitelabel?.pdf_logo_mini" alt="logo" class="footer-mini__logo" />
            <span class="footer-mini__domain">
              <strong>{{ documentWhitelabel?.domain ? documentWhitelabel.domain : 'autentique.com.br' }}</strong>
            </span>
          </div>
          <div class="footer-mini__center">
            <span class="footer-mini__icon material-icons"><i class="fa-regular fa-file-certificate"></i></span>
            <span class="footer-mini__hash">{{ document?.id || 'b904*916d6dcdedb1dcbf16b63c54f612*4c40fe3873*e6' }}</span>
          </div>
          <div class="footer-mini__right">
            <span>{{ translatedMiniFooterPage[$index] }}</span>
          </div>
        </div>
      } @else {
        <!-- STANDARD FOOTER PREVIEW (original) -->
        <div class="footer" [style.height]="maxFooterHeight + 'px'">
          <div class="divisor">
            <div class="autLogo">
              <div class="autLogo__image">
                <img [src]="documentWhitelabel?.pdf_logo_mini" alt="" />
              </div>
            </div>
            <div class="text">
              <p class="text_first">
                {{ translateQualified }}
              </p>
              @if (!qualified) {
                <p class="text_hash" [innerHTML]="translatedHash"></p>
              }
              <p class="text_valida" [innerHTML]="translatedQRCode"></p>
            </div>
          </div>
          <div class="qrCode">
            <p class="qrCode__text">{{ translatedValidator }}</p>
            <qrcode [cssClass]="'qrCode__image'" [width]="52" [qrdata]="qrCodeUrl()" [elementType]="'svg'"></qrcode>
          </div>
        </div>
      }
    }
  </div>
}
